import {InjectionToken} from '@angular/core';

export interface MxReferencedEntityService {
    hasAccess(entityName: string): boolean;
    getReferencedEntityMapping(entityName: string, row: any): string;
    getReferencedEntityFilter(entityName: string): string;
    getReferencedReportMapping(referencedReport: string): string;
}
export const MX_REFERENCE_SERVICE_TOKEN = new InjectionToken<MxReferencedEntityService>('MX_REFERENCE_SERVICE_TOKEN');
